import { ChevronRight } from "@mui/icons-material";
import MuiLink from "@mui/material/Link";
import React from "react";
import type { To } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";

type LinkProps = {
  children: React.ReactNode;
  href?: string;
  to?: To;
  onClick?: () => void;
  isExternal?: boolean;
};

const Link = ({
  children,
  href,
  to,
  onClick,
  isExternal = true,
}: LinkProps) => {
  const commonStyles = {
    fontWeight: 700,
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
  };

  const chevronStyles = (theme: any) => ({
    fontSize: "24px",
    margin: `1px 0 0 ${theme.spacing(1)}px`,
  });

  if (isExternal && href) {
    return (
      <MuiLink
        variant="body2"
        color="primary"
        href={href}
        sx={commonStyles}
        onClick={onClick}
        target="_blank"
        rel="noopener"
      >
        <span>{children}</span>
        <ChevronRight sx={chevronStyles} />
      </MuiLink>
    );
  }
  return (
    <MuiLink
      component={RouterLink}
      variant="body2"
      color="primary"
      to={to || ""}
      sx={commonStyles}
      onClick={onClick}
    >
      <span>{children}</span>
      <ChevronRight sx={chevronStyles} />
    </MuiLink>
  );
};

export default Link;
